import { InjectionToken } from '@angular/core';
import { NK_PARSER, NK_PARSER_DICTIONARY } from '@nitro/core/common';
import * as _moment from 'moment';
// eslint-disable-next-line no-duplicate-imports
import { DurationInputArg1, DurationInputArg2, Moment } from 'moment';

const moment = _moment;
// Keep next line to import NK_PARSER from @nitro/core and to prevent relative import from deploy
const _nkparser: NK_PARSER<Moment> = null;

export const NK_DATE_TIME_PARSERS = new InjectionToken<NK_PARSER_DICTIONARY<Moment>>('NK_DATE_TIME_PARSERS');

export const NK_DEFAULT_DATE_TIME_PARSERS: NK_PARSER_DICTIONARY<Moment> = new Map([
  [
    'ago',
    (val: string, locale?: string) => {
      const rx = /^([0-9]+)\s(\w+)\sago$/.exec(val);
      if (rx && rx.length === 3) {
        return moment().subtract(Number(rx[1]) as DurationInputArg1, rx[2] as DurationInputArg2);
      } else {
        return null;
      }
    }
  ],
  [
    'now',
    (val: string, locale?: string) => {
      const nowString = { en: 'now', ro: 'acum' };
      if (val.trim() === (nowString[locale || ''] || 'now')) {
        return moment();
      } else {
        return null;
      }
    }
  ]
]);
